/* Sage By Mala redesign — Phase 1. Exposes window.SBM; Phase 5 adds the add-to-bag label patch; Phase 6b adds SBM.loginGate; Phase 8 adds SBM.carouselResize. */
(function () {
  'use strict';
  /**
   * market(): the shopper's country as the checkout routing sees it.
   * Reads localStorage "sbm_cc" ({v:'IN', t:<ms>}) exactly like sbmShopperCountry()
   * in layout/theme.liquid. Returns 'IN', another ISO-3166 code, or null when unknown.
   */
  function market() {
    try {
      var c = JSON.parse(localStorage.getItem('sbm_cc') || 'null');
      if (c && c.v) return String(c.v).toUpperCase();
    } catch (e) {}
    return null;
  }
  window.SBM = window.SBM || {};
  window.SBM.market = market;

  /* "Add to bag" everywhere the theme JS relabels the button (PDP, quick view, sticky bar).
     render_bottom.liquid defines window.T4SProductStrings after this file runs; the setter
     rewrites addToCart as soon as it is assigned. */
  (function () {
    var v;
    function patch(o) { if (o && typeof o === 'object') { o.addToCart = 'Add to bag'; } return o; }
    if (window.T4SProductStrings) { patch(window.T4SProductStrings); return; }
    try {
      Object.defineProperty(window, 'T4SProductStrings', {
        configurable: true, enumerable: true,
        get: function () { return v; },
        set: function (o) { v = patch(o); }
      });
    } catch (e) {}
  })();

  /* ------------------------------------------------------------------------------------
   * Phase 6b — SBM.loginGate
   * KwikPass (app embed kp_login) must stay as is for India. For every other known market
   * the shopper goes to Shopify's hosted login (/account/login → account.sagebymala.com)
   * and never sees a KwikPass surface.
   *
   * How KwikPass attaches (see phase6b/findings.md): the embed renders a hidden
   * <div id="d2c-pass"><iframe id="iframe-kp" src="https://pdp.gokwik.co/kwikpass/kwikpass.html">
   * in the body; kp-shopify-app-sdk.js binds ONE delegated click listener on document.body
   * (bubble phase, at window load) that matches any <a> whose pathname is /account,
   * /account/login*, /account/register*, ends with "account" or is /account/addresses,
   * preventDefaults it and shows that iframe full-screen. So the gate:
   *   (a) listens for clicks on `document` in the CAPTURE phase (fires before any body
   *       listener), stops propagation and navigates to /account/login itself;
   *   (b) replaces every account entry anchor with a clone (drops per-node listeners and the
   *       theme's login-drawer data attributes) whose href is /account/login;
   *   (c) removes KwikPass iframes/containers/floating triggers on sight, now and whenever
   *       they are (re)inserted (MutationObserver), which also kills the silent SSO and any
   *       auto-open popup — the iframe is the modal;
   *   (d) the observer also re-gates anchors that arrive with AJAX content (cart drawer,
   *       quick view, mobile drawer).
   * Activation: only when market() is a known code other than 'IN'. null/unknown = India.
   * On a first visit the currency overlay writes sbm_cc asynchronously (geojs), so the gate
   * polls market() for 20 s and activates as soon as a non-IN code appears. It never
   * deactivates within a page view. Kill switch: localStorage.sbm_login_gate === 'off'.
   * Checkout buttons and Shopflo are not touched (no `name=checkout`, no /checkout hrefs).
   * ---------------------------------------------------------------------------------- */
  (function () {
    var LOGIN = '/account/login';
    var KP_SELECTOR = [
      '#iframe-kp', '#d2c-pass', 'iframe[src*="gokwik.co"]', 'iframe[src*="kwikpass"]',
      '[id^="kwikpass-"]', '[id^="kp-login"]', '[id^="kp-sso"]', '[id^="icon-kwikpass"]',
      '[id^="icon-close-kwikpass"]', '[id^="logout-button-"]', '#loggedin-icons',
      '[class*="kwikpass-drawer"]', '[class*="kp-popup"]', '[class*="kp-marketing"]'
    ].join(',');
    var active = false, observer = null, pollTimer = null;

    function enabled() {
      try { if (localStorage.getItem('sbm_login_gate') === 'off') return false; } catch (e) {}
      return true;
    }
    function shouldGate() {
      var m = market();
      return !!m && m !== 'IN';
    }
    function anchorPath(a) {
      try { return a.pathname || new URL(a.getAttribute('href') || '', location.origin).pathname; } catch (e) { return ''; }
    }
    /* Same matching rule as the KwikPass SDK, minus logout. */
    function isAccountAnchor(a) {
      if (!a || a.tagName !== 'A') return false;
      var href = a.getAttribute('href');
      if (!href || href.indexOf('javascript:') === 0 || href.charAt(0) === '#') return false;
      var p = anchorPath(a);
      if (!p || p.indexOf('/account/logout') === 0) return false;
      return p === '/account' || p.indexOf('/account/login') === 0 || p.indexOf('/account/register') === 0 ||
        /account\/?$/.test(p) || p.indexOf('customer_authentication') !== -1 || p === '/account/addresses';
    }
    function retarget(a) {
      try {
        if (a.getAttribute('data-sbm-gated') === '1') return;
        var c = a.cloneNode(true);
        c.setAttribute('href', LOGIN);
        c.setAttribute('data-sbm-gated', '1');
        c.removeAttribute('data-drawer-options');
        c.removeAttribute('data-drawer-delay-');
        c.removeAttribute('data-drawer-delay');
        c.removeAttribute('data-login-sidebar');
        c.removeAttribute('onclick');
        c.classList.remove('kwikpass-loading');
        if (a.parentNode) a.parentNode.replaceChild(c, a);
      } catch (e) {}
    }
    function gateAnchors(root) {
      try {
        var list = (root && root.querySelectorAll) ? root.querySelectorAll('a[href]') : [];
        for (var i = 0; i < list.length; i++) if (isAccountAnchor(list[i])) retarget(list[i]);
        if (root && root.tagName === 'A' && isAccountAnchor(root)) retarget(root);
      } catch (e) {}
    }
    function removeKp(root) {
      try {
        if (!root) return;
        if (root.nodeType === 1 && root.matches && root.matches(KP_SELECTOR)) { root.parentNode && root.parentNode.removeChild(root); return; }
        var list = root.querySelectorAll ? root.querySelectorAll(KP_SELECTOR) : [];
        for (var i = list.length - 1; i >= 0; i--) { var n = list[i]; if (n.parentNode) n.parentNode.removeChild(n); }
      } catch (e) {}
    }
    function onClickCapture(ev) {
      try {
        var t = ev.target;
        var a = t && t.closest ? t.closest('a[href]') : null;
        if (!a || !isAccountAnchor(a)) return;
        ev.stopPropagation();
        ev.preventDefault();
        window.location.assign(LOGIN);
      } catch (e) {}
    }
    function sweep() { removeKp(document); gateAnchors(document); }
    function activate() {
      if (active) return;
      active = true;
      try {
        document.addEventListener('click', onClickCapture, true);
        sweep();
        observer = new MutationObserver(function (ms) {
          try {
            for (var i = 0; i < ms.length; i++) {
              var added = ms[i].addedNodes;
              for (var j = 0; j < added.length; j++) {
                var n = added[j];
                if (n.nodeType !== 1) continue;
                removeKp(n);
                if (n.parentNode) gateAnchors(n);
              }
              if (ms[i].type === 'attributes') {
                var tg = ms[i].target;
                if (tg && tg.nodeType === 1) { removeKp(tg); if (tg.tagName === 'A' && isAccountAnchor(tg)) retarget(tg); }
              }
            }
          } catch (e) {}
        });
        observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'class', 'href', 'id'] });
        /* Safety sweeps for content swapped without a mutation we saw (e.g. innerHTML of a node we already removed). */
        var ticks = 0, iv = setInterval(function () { sweep(); if (++ticks >= 10) clearInterval(iv); }, 1000);
        document.addEventListener('DOMContentLoaded', sweep);
        window.addEventListener('load', sweep);
        window.addEventListener('pageshow', sweep);
      } catch (e) {}
    }
    function maybeActivate() {
      if (!enabled()) return false;
      if (shouldGate()) { activate(); return true; }
      return false;
    }
    try {
      if (!enabled()) return;
      if (!maybeActivate()) {
        var n = 0;
        pollTimer = setInterval(function () {
          if (maybeActivate() || ++n >= 40) clearInterval(pollTimer);
        }, 500);
      }
    } catch (e) {}
    window.SBM.loginGate = {
      isActive: function () { return active; },
      activate: function () { if (enabled()) activate(); },
      sweep: sweep
    };
  })();

  /* ------------------------------------------------------------------------------------
   * Phase 7 fix — SBM.swatchA11y
   * The theme renders size/colour pills as <div data-swatch-item class="t4s-swatch__item"> with no
   * tabindex or role, so keyboard users cannot reach them. Give every pill inside a product form
   * tabindex="0" + role="radio" (aria-checked mirrors the is--selected / is-selected / active class)
   * and let Enter/Space trigger the theme's own click handler. Runs on DOMContentLoaded and again
   * for nodes inserted later (quick view, sticky bar, AJAX re-renders) via a MutationObserver.
   * ---------------------------------------------------------------------------------- */
  (function () {
    var SEL = '.t4s-swatch [data-swatch-item], .t4s-swatch .t4s-swatch__item';
    var SELECTED = /(^|\s)(is--selected|is-selected|active)(\s|$)/;
    function sync(el) {
      try { el.setAttribute('aria-checked', SELECTED.test(el.className) ? 'true' : 'false'); } catch (e) {}
    }
    function prep(el) {
      try {
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        if (!el.hasAttribute('role')) el.setAttribute('role', 'radio');
        if (!el.hasAttribute('aria-label')) {
          var v = el.getAttribute('data-value') || el.textContent;
          if (v && v.trim()) el.setAttribute('aria-label', v.trim());
        }
        sync(el);
      } catch (e) {}
    }
    function scan(root) {
      try {
        var r = root && root.querySelectorAll ? root : document;
        var list = r.querySelectorAll(SEL);
        for (var i = 0; i < list.length; i++) prep(list[i]);
        if (root && root.nodeType === 1 && root.matches && root.matches(SEL)) prep(root);
        var groups = r.querySelectorAll('.t4s-swatch .t4s-swatch__list');
        for (var g = 0; g < groups.length; g++) if (!groups[g].hasAttribute('role')) groups[g].setAttribute('role', 'radiogroup');
      } catch (e) {}
    }
    function onKey(ev) {
      try {
        if (ev.key !== 'Enter' && ev.key !== ' ' && ev.key !== 'Spacebar') return;
        var t = ev.target;
        var el = t && t.closest ? t.closest(SEL) : null;
        if (!el) return;
        ev.preventDefault();
        el.click();
      } catch (e) {}
    }
    function start() {
      scan(document);
      document.addEventListener('keydown', onKey, false);
      try {
        new MutationObserver(function (ms) {
          for (var i = 0; i < ms.length; i++) {
            var m = ms[i];
            if (m.type === 'attributes') { var tg = m.target; if (tg && tg.nodeType === 1 && tg.matches && tg.matches(SEL)) sync(tg); continue; }
            var added = m.addedNodes;
            for (var j = 0; j < added.length; j++) { var n = added[j]; if (n.nodeType === 1) scan(n); }
          }
        }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      } catch (e) {}
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    window.SBM.swatchA11y = { scan: scan };
  })();
  /* ------------------------------------------------------------------------------------
   * Phase 8 perf — SBM.carouselResize
   * The theme's ResizeObserver (interactable.min.js, opt-in via [data-t4s-resizeobserver])
   * resizes a product carousel 28 ms after EVERY card's callback, including each card's
   * initial callback, and its debounce never fires (fresh local timer): 18 full carousel
   * resizes per home load, each re-selecting slides and rewriting aria-hidden on every card.
   * sections/featured-collection.liquid now marks its slider [data-sbm-resizeobserver]
   * instead. This observer keeps the behaviour that matters (re-measure when a card really
   * changes size, e.g. a late font swap) with one debounced resize per carousel and nothing
   * on the initial callbacks. Window resizes are still handled by Flickity itself.
   * ---------------------------------------------------------------------------------- */
  (function () {
    if (!window.ResizeObserver) return;
    var SEL = '[data-sbm-resizeobserver]';
    var sizes = new WeakMap(), timers = new WeakMap(), watched = new WeakSet();
    function resize(box) {
      try {
        var $ = window.jQuery_T4NT;
        if ($ && $.fn && $.fn.flickityt4s && box.classList.contains('flickityt4s-enabled')) $(box).flickityt4s('resize');
      } catch (e) {}
    }
    var ro = new ResizeObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var el = entries[i].target, r = entries[i].contentRect;
        var w = Math.round(r.width), h = Math.round(r.height), prev = sizes.get(el);
        sizes.set(el, [w, h]);
        if (!prev || (prev[0] === w && prev[1] === h)) continue;
        var box = el.closest(SEL);
        if (!box) continue;
        clearTimeout(timers.get(box));
        timers.set(box, setTimeout(resize.bind(null, box), 100));
      }
    });
    function scan() {
      var boxes = document.querySelectorAll(SEL), pending = 0;
      for (var i = 0; i < boxes.length; i++) {
        if (!boxes[i].classList.contains('flickityt4s-enabled')) { pending++; continue; }
        var cards = boxes[i].querySelectorAll('.t4s-product');
        for (var j = 0; j < cards.length; j++) if (!watched.has(cards[j])) { watched.add(cards[j]); ro.observe(cards[j]); }
      }
      return pending;
    }
    function start() {
      var n = 0;
      (function poll() { if (scan() > 0 && ++n < 50) setTimeout(poll, 300); })();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    window.SBM.carouselResize = { scan: scan };
  })();
})();
